/* unplugin-vue-components disabled */import script from "./headNav.vue?vue&type=script&setup=true&lang=js"
export * from "./headNav.vue?vue&type=script&setup=true&lang=js"

import "./headNav.vue?vue&type=style&index=0&id=dc717a60&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc717a60"]])

export default __exports__